'use strict';
/**
 * Logging level constants.
 */
export default {
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
  SUCCESS: "success"
};